module.exports = __webpack_public_path__ + "static/media/logo.209ab650.svg";